import React from "react";
import { MyLeaveBarItemView } from "./bar-item-view";
import { useMyLeaveBarItem as useMyLeaveBarItemDI } from "./use-bar-item";

export interface MyLeaveBarItemProps {
  percent: number;
  color: string;
  value: string;
  label: string;
  isFirst?: boolean;
  isLast?: boolean;
  onlyBar?: boolean;
  useMyLeaveBarItem?: typeof useMyLeaveBarItemDI;
}
export const MyLeaveBarItem: React.FC<MyLeaveBarItemProps> = ({
  percent,
  color,
  value,
  label,
  isLast = false,
  isFirst = false,
  onlyBar,
  useMyLeaveBarItem = useMyLeaveBarItemDI,
}: MyLeaveBarItemProps) => {
  const { TooltipNode, boxCurve, formattedValue } = useMyLeaveBarItem({
    label,
    value,
    isFirst,
    isLast,
    onlyBar,
  });

  return (
    <MyLeaveBarItemView
      TooltipNode={TooltipNode}
      boxCurve={boxCurve}
      color={color}
      label={label}
      percent={percent}
      value={formattedValue}
      onlyBar={onlyBar}
    />
  );
};
